import { StepData, SubStep } from "../components/CompleteAccount/Stepper";

export const returnStepperData = (stepperData: StepData[]) => {
  return stepperData?.map((item) => ({
    ...item,
    subSteps: [...(item?.subSteps as SubStep[])]?.map((step) => ({
      ...step,
      path: step?.label?.toLowerCase()?.split(" ")?.join("-"),
    })),
  }));
};
